(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zm-design"] && !Shopify.designMode) return;
  try {
    document.addEventListener('cart:count:update', (event) => {
  const count = event.detail?.item_count;
  if (typeof count === 'number') document.querySelectorAll('[data-zm-cart-count]').forEach((element) => { element.textContent = count; });
});
function initializeZveltMaster(){
  document.querySelectorAll('[data-zm-material]').forEach(panel=>{
    if(panel.dataset.zmReady)return;
    panel.dataset.zmReady='true';
    panel.querySelectorAll('[data-zm-finish]').forEach(button=>button.addEventListener('click',()=>{
      panel.querySelectorAll('[data-zm-finish]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
      const image=panel.querySelector('.zm-material-image');
      image.removeAttribute('srcset');image.src=button.dataset.zmSrc;image.alt=button.dataset.zmAlt||button.dataset.zmFinish;
      panel.querySelector('.zm-selected-finish').textContent=button.dataset.zmFinish;
      panel.querySelector('[data-zm-finish-link]').href=button.dataset.zmUrl;
    }));
  });
  const menus=[...document.querySelectorAll('.zm-nav-details,.zm-mobile-nav')];
  menus.forEach(menu=>{if(menu.dataset.zmReady)return;menu.dataset.zmReady='true';menu.addEventListener('toggle',()=>{if(menu.open)menus.forEach(other=>{if(other!==menu)other.open=false})});menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus()}})});
  if(!document.documentElement.dataset.zmDismiss){document.documentElement.dataset.zmDismiss='true';document.addEventListener('click',event=>{menus.forEach(menu=>{if(menu.open&&!menu.contains(event.target))menu.open=false})})}
}
document.addEventListener('DOMContentLoaded',initializeZveltMaster);
document.addEventListener('shopify:section:load',initializeZveltMaster);
if(document.readyState!=='loading')initializeZveltMaster();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zm-resources-style"] && !Shopify.designMode) return;
  try {
    function initializeZveltResources(){
  document.querySelectorAll('[data-zr-library]').forEach(library=>{
    if(library.dataset.zrReady)return;
    library.dataset.zrReady='true';
    const controls=library.querySelector('.zr-library-controls');
    const input=library.querySelector('[data-zr-search]');
    const buttons=[...library.querySelectorAll('[data-zr-filter]')];
    const cards=[...library.querySelectorAll('[data-zr-card]')];
    const status=library.querySelector('[data-zr-count]');
    const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[×x″"']/g,' ').replace(/\s+/g,' ').trim();
    let family='all';
    const update=()=>{
      const query=normalize(input.value);let count=0;
      cards.forEach(card=>{const visible=(family==='all'||card.dataset.zrFamily===family)&&normalize(card.dataset.zrSearchText).includes(query);card.hidden=!visible;if(visible)count++;});
      status.textContent=count===1?status.dataset.zrOne:status.dataset.zrTemplate.replace('[count]',count);
      library.querySelector('[data-zr-empty]').hidden=count!==0;
      buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.zrFilter===family)));
    };
    buttons.forEach(button=>button.addEventListener('click',()=>{family=button.dataset.zrFilter;update();}));
    input.addEventListener('input',update);
    library.querySelector('[data-zr-clear]').addEventListener('click',()=>{input.value='';family='all';update();input.focus();});
    controls.hidden=false;update();
  });
}
function openZveltResourceAnchor(){
  if(!location.hash)return;
  let id;try{id=decodeURIComponent(location.hash.slice(1));}catch{return;}
  const target=document.getElementById(id);
  if(!target)return;
  const detail=target.closest('details.zr-detail');
  if(detail){detail.open=true;detail.scrollIntoView({block:'start'});}
}
document.addEventListener('DOMContentLoaded',()=>{initializeZveltResources();openZveltResourceAnchor();});
document.addEventListener('shopify:section:load',initializeZveltResources);
window.addEventListener('hashchange',openZveltResourceAnchor);
if(document.readyState!=='loading'){initializeZveltResources();openZveltResourceAnchor();}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zm-shopping-style"] && !Shopify.designMode) return;
  try {
    function initializeZveltChooser(){
  document.querySelectorAll('.zp-menu a[href*="#choisir"]').forEach(link=>{
    if(link.dataset.zpReady)return;
    link.dataset.zpReady='true';
    link.addEventListener('click',()=>{
      let parent=link.parentElement;
      while(parent){if(parent.tagName==='DETAILS')parent.open=false;parent=parent.parentElement;}
    });
  });
  document.querySelectorAll('[data-zp-chooser]').forEach(chooser=>{
    if(chooser.dataset.zpReady)return;
    chooser.dataset.zpReady='true';
    const controls=chooser.querySelector('[data-zp-controls]');
    const preferences=chooser.querySelector('[data-zp-preference]');
    const preferenceInputs=[...chooser.querySelectorAll('input[name="zp-preference"]')];
    const results=[...chooser.querySelectorAll('[data-zp-result]')];
    const reset=chooser.querySelector('[data-zp-reset]');
    const announcement=chooser.querySelector('[data-zp-announcement]');
    function showResult(family){
      results.forEach(result=>{result.hidden=result.dataset.zpResult!==family;});
      const result=results.find(item=>item.dataset.zpResult===family);
      announcement.textContent=result?result.dataset.zpAnnouncementText:'';
    }
    chooser.querySelectorAll('input[name="zp-space"]').forEach(input=>input.addEventListener('change',()=>{
      preferenceInputs.forEach(item=>{item.checked=false;});
      preferences.hidden=input.value!=='shower';
      reset.hidden=false;
      showResult(input.value==='wc'?'wc-niche':null);
    }));
    preferenceInputs.forEach(input=>input.addEventListener('change',()=>showResult(input.value)));
    reset.addEventListener('click',()=>{
      chooser.querySelectorAll('input[type="radio"]').forEach(input=>{input.checked=false;});
      preferences.hidden=true;reset.hidden=true;showResult(null);
      chooser.querySelector('input[name="zp-space"]').focus();
    });
    controls.hidden=false;
  });
}
document.addEventListener('DOMContentLoaded',initializeZveltChooser);
document.addEventListener('shopify:section:load',initializeZveltChooser);
if(document.readyState!=='loading')initializeZveltChooser();
  } catch(e) { console.error(e); }
})();

})();
